export const productGroups = [
  {
    id: 1,
    name: "SMARTLINE outwards opening doors",
    description: "CE-marked outwards opening exterior door for private houses",
    models: [
      {
        id: "F000-GL006",
        name: "F000-GL006",
        image: "/60mm.png",
        description: "SMARTLINE outwards opening exterior door for private houses.",
        keyFeatures: [
          "CE-marked, U-value 0,77 for blind doors / 1,0 for glass doors",
          "door thickness 60 mm",
          "frame depth 105 mm"
        ],
        technicalDetails: [
          "Door thickness 60 mm",
          "Pine 1-step frame 44 x 105 mm",
          "2 Aluminum sheet in a door",
          "3,2 mm HDF surface",
          "Insulation EPS (50 mm)",
          "Sealing in a door",
          "Threshold oak, optional grey Accoya",
          "Lock-case 565",
          "Hinges 3248-110, 2 pcs",
          "2K Clear glass (only for glass doors)",
          "Standard sizes 9x20/21; 9,5x20,5; 10x20/21"
        ]
      }
    ]
  },
  {
    id: 2,
    name: "SMARTLINE inwards opening door",
    description: "CE-marked inwards opening exterior door for private houses",
    models: [
      {
        id: "F000-GL006-IN",
        name: "F000-GL006",
        image: "/60mmInswing.png",
        description: "SMARTLINE inwards opening exterior door for private houses.",
        keyFeatures: [
          "U-value 0,77 for blind doors / 1,0 for glass doors",
          "door thickness 60 mm",
          "frame depth 115 mm"
        ],
        technicalDetails: [
          "Door thickness 60 mm",
          "Pine 2-step frame 56 x 115 mm",
          "2 Aluminum sheet in a door",
          "3,2 mm HDF surface",
          "Insulation EPS (50 mm)",
          "Sealing in a door",
          "Threshold Aluminum",
          "Lock-case 565",
          "Hinges 3248-110, 2 pcs",
          "2K Clear glass (only for glass doors)",
          "Standard sizes 9x20/21; 9,5x20,5; 10x20/21"
        ]
      }
    ]
  },
  {
    id: 3,
    name: "SMARTLINE PLUS outwards opening door",
    description: "CE-marked outwards opening exterior door for private houses",
    models: [
      {
        id: "F000-GL006-PLUS",
        name: "F000-GL006",
        image: "/60mm.png",
        description: "SMARTLINE PLUS outwards opening exterior door for private houses.",
        keyFeatures: [
          "U-value 0,77 for blind doors / 1,0 for glass doors",
          "door thickness 60 mm",
          "frame depth 115 mm"
        ],
        technicalDetails: [
          "Door thickness 60 mm",
          "Pine 1-step frame 56 x 115 mm",
          "2 Aluminum sheet in a door",
          "3,2 mm HDF surface",
          "Insulation EPS (50 mm)",
          "Sealing in a door",
          "Threshold Aluminum",
          "3-point lock FIX2150, optional 565, ASSA 2002, ASSA 410-50",
          "Hinges 3248-110, 3 pcs",
          "2K Clear glass (only for glass doors)",
          "Standard sizes 9x20/21; 9,5x20,5; 10x20/21"
        ]
      }
    ]
  },
  {
    id: 4,
    name: "Cottage doors 10-degrees",
    description: "Door for cold storages where temperature difference between the inside and outside do not exceed 10°C",
    models: [
      {
        id: "C10",
        name: "C10",
        image: "/Cottage.png",
        description: "COTTAGE DOOR 10°C for cold stores and sheds",
        keyFeatures: [
          "pine paneling on outer side",
          "door thickness 47 mm",
          "frame depth 92 mm"
        ],
        technicalDetails: [
          "Door thickness 47 mm",
          "Pine 1-step frame 42 x 92 mm",
          "3-layer Meranti plywood 2,7 mm",
          "Insulation EPS (33 mm)",
          "Sealing in a frame",
          "Threshold pine, same profile as a frame",
          "lock-case 565",
          "Hinges 3248-110, 2 pcs",
          "4 mm Clear glass (only for glass doors)",
          "Standard sizes 9x19/20; 9,5x20,5; 9/10 x 20/21M"
        ]
      }
    ]
  },
  {
    id: 5,
    name: "Meranti doors",
    description: "Doors for cold storage rooms and sheds where temperature difference between the inside and outside do not exceed 10°C",
    models: [
      {
        id: "M10",
        name: "M10",
        image: "/Meranti.png",
        description: "Meranti doors for cold stores and sheds",
        keyFeatures: [
          "Meranti plywood surface on both sides",
          "door thickness 47 mm",
          "frame depth 92 mm"
        ],
        technicalDetails: [
          "Door thickness 47 mm",
          "Pine 1-step frame 42 x 92 mm",
          "3-layer Meranti plywood 2,7 mm",
          "Insulation EPS (40 mm)",
          "Sealing in a frame",
          "Threshold pine, same profile as a frame",
          "lock-case 565",
          "Hinges 3248-110, 2 pcs",
          "4 mm Clear glass (only for glass doors)",
          "Standard sizes 9x19/20; 9,5x20,5; 9/10 x 20/21M"
        ]
      }
    ]
  },
  {
    id: 6,
    name: "18-degree doors",
    description: "Doors for warm storage rooms and sheds where temperature difference between the inside and outside do not exceed 18°C",
    models: [
      {
        id: "W20",
        name: "W20",
        image: "/18Deg.png",
        description: "18° doors for warm stores and sheds",
        keyFeatures: [
          "Meranti plywood surface on both sides",
          "door thickness 47 mm",
          "frame depth 92 mm"
        ],
        technicalDetails: [
          "Door thickness 47 mm",
          "Pine 1-step frame 42 x 92 mm",
          "3-layer Meranti plywood 2,7 mm",
          "Insulation EPS (40 mm)",
          "Sealing in a frame",
          "Threshold pine, same profile as a frame; optional oak",
          "Lock-case 565",
          "Hinges 3248-110, 2 pcs",
          "2K Clear glass (only for glass doors)",
          "Standard sizes 9x19/20; 9,5x20,5; 9/10 x 20/21M"
        ]
      }
    ]
  }
];
